import { render, staticRenderFns } from "./DateHolReplaceAppView.vue?vue&type=template&id=84e44f34&"
import script from "./DateHolReplaceAppView.vue?vue&type=script&lang=js&"
export * from "./DateHolReplaceAppView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports